function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { colors } from '@airwallex/global';
import { IconView, IconViewOff } from '@airwallex/glyphs';
import { Tooltip as ReactTippy } from 'react-tippy';
import snakeCase from 'lodash.snakecase';
import Label from '../label';
import HelpText from '../helpText';
import ReduxPasswordField from './reduxField';
import PasswordChecker from './passwordChecker';
import { InputContainer, IconHolder, InputHolder, Input, Header, SubtitleContainer } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/core";

var IconInput = function IconInput(_ref) {
  var icon = _ref.icon,
      isFocused = _ref.isFocused,
      isHovered = _ref.isHovered,
      isErrored = _ref.isErrored,
      isWarning = _ref.isWarning,
      isTouched = _ref.isTouched,
      isSubmitted = _ref.isSubmitted,
      onToggle = _ref.onToggle;

  if (!icon) {
    return null;
  }

  var Icon = icon;
  return ___EmotionJSX(IconHolder, {
    isFocused: isFocused,
    isHovered: isHovered,
    isErrored: isErrored,
    isWarning: isWarning,
    isTouched: isTouched,
    isSubmitted: isSubmitted,
    onClick: onToggle
  }, ___EmotionJSX(Icon, {
    size: 16,
    color: colors.darkGrey
  }));
};

IconInput.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.any]),
  isFocused: PropTypes.bool,
  isHovered: PropTypes.bool,
  isErrored: PropTypes.bool,
  isWarning: PropTypes.bool,
  isTouched: PropTypes.bool,
  isSubmitted: PropTypes.bool,
  onToggle: PropTypes.func
};
var tooltipStyle = {
  backgroundColor: colors.white,
  color: colors.ink,
  padding: 0
};
export var PasswordField = function PasswordField(props) {
  var label = props.label,
      name = props.name,
      placeholder = props.placeholder,
      _props$value = props.value,
      value = _props$value === void 0 ? '' : _props$value,
      hideLabel = props.hideLabel,
      style = props.style,
      isFocused = props.isFocused,
      help = props.help,
      _props$meta = props.meta,
      meta = _props$meta === void 0 ? {
    error: '',
    warning: ''
  } : _props$meta,
      _props$passwordChecke = props.passwordChecker,
      passwordChecker = _props$passwordChecke === void 0 ? {} : _props$passwordChecke,
      subtitle = props.subtitle,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      rest = _objectWithoutProperties(props, ["label", "name", "placeholder", "value", "hideLabel", "style", "isFocused", "help", "meta", "passwordChecker", "subtitle", "onFocus", "onBlur"]);

  var error = meta.error,
      warning = meta.warning,
      touched = meta.touched,
      submitFailed = meta.submitFailed;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocusedState = _useState2[0],
      setIsFocusedState = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isHoveredState = _useState4[0],
      setIsHoveredState = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showPassword = _useState6[0],
      setShowPassword = _useState6[1];

  var toggleType = useCallback(function () {
    setShowPassword(function (val) {
      return !val;
    });
  }, []);
  var hoverElement = useCallback(function () {
    setIsHoveredState(true);
  }, []);
  var unHoverElement = useCallback(function () {
    setIsHoveredState(false);
  }, []);
  var onInputFocus = useCallback(function (e) {
    setIsFocusedState(true);
    onFocus && onFocus(e);
  }, [onFocus]);
  var onInputBlur = useCallback(function (e) {
    setIsFocusedState(false);
    onBlur && onBlur(e);
  }, [onBlur]);
  var inputType = showPassword ? 'text' : 'password';
  var isErrored = !!error;
  var isWarning = !!warning;
  return ___EmotionJSX(InputContainer, {
    css: style,
    "data-test": snakeCase("".concat(meta.form, " ").concat(name)),
    onMouseOver: hoverElement,
    onMouseLeave: unHoverElement
  }, subtitle ? ___EmotionJSX(Header, null, ___EmotionJSX(Label, {
    id: name,
    hideLabel: hideLabel
  }, label), ___EmotionJSX(SubtitleContainer, null, subtitle)) : ___EmotionJSX(Label, {
    id: name,
    hideLabel: hideLabel
  }, label), ___EmotionJSX(InputHolder, {
    isFocused: isFocused || isFocusedState,
    isHovered: isHoveredState,
    isErrored: isErrored,
    isWarning: isWarning,
    isTouched: touched,
    isSubmitted: submitFailed
  }, ___EmotionJSX(IconInput, {
    icon: showPassword ? IconView : IconViewOff,
    isFocused: isFocused,
    isHovered: isHoveredState,
    isErrored: isErrored,
    isWarning: isWarning,
    isTouched: touched,
    isSubmitted: submitFailed,
    onToggle: function onToggle() {
      return toggleType();
    }
  }), ___EmotionJSX(Input, _extends({
    placeholder: placeholder,
    name: name,
    id: name,
    value: value,
    onFocus: onInputFocus,
    onBlur: onInputBlur
  }, rest, {
    type: inputType
  })), ___EmotionJSX(ReactTippy, {
    animateFill: false,
    position: 'bottom-start',
    disabled: !Object.prototype.hasOwnProperty.call(passwordChecker, 'password'),
    theme: "light",
    open: isFocused,
    trigger: "manual",
    distance: 4,
    style: tooltipStyle,
    sticky: true,
    html: ___EmotionJSX(PasswordChecker, {
      password: passwordChecker.password,
      long: passwordChecker.long,
      upper: passwordChecker.upper,
      lower: passwordChecker.lower,
      symbol: passwordChecker.symbol,
      invalid: passwordChecker.invalid,
      securityTip: passwordChecker.securityTip,
      passwordRequirements: passwordChecker.passwordRequirements
    })
  })), ___EmotionJSX(HelpText, {
    text: help
  }), (touched || submitFailed) && (isErrored || isWarning) && ___EmotionJSX(HelpText, {
    text: error || warning,
    isErrored: isErrored,
    isWarning: isWarning
  }));
};
export { PasswordField as default, ReduxPasswordField };